import zLib                 from 'util/ZLib';
import SettingsModel        from 'SettingsModel.js';
import listService          from 'ListService';
import XJService            from 'xml/XJService';
import toolboxItemMapService from 'ToolboxItemMapService';
import util                 from 'util/Util.js';
import restService from 'RestService.js';
import alertDialogView from 'common-views/AlertDialogView.js';
import {Model}          from 'backbone';
import textConstants        from 'TextConstants';
import SessionTimeoutModal from '../views/common-views/SessionTimeoutModal';
import constants    from 'Constants';
import undoService      from 'UndoService';

class UserService {
    constructor() {
    }

    // Expects a COMPORESSED XML settings. Stores it as cleartext.
    setUserSettings(settings) {
        try {
            let xml = '<Settings edTbW="220" edShSM="true" moShHC="false" moShAS="false" maInWs3="20,120,120,60,80,80" maInWs4="20,120,100,60,40,80,80" maInWs2="140,100,60,80,80" maUsWs="160,160,50,80,40" edSt="800, 500" edDs="460,490" edShHC="255" edBrTbC="254" maCoFfDg="" edTbLaTbC="252" maNoWs2="19,140,75,40,80,80" edPbCaC="2044" edTbScTbC="252" edNoHtml="false" edNo="600,600" maNoWs1="19,300,75,40" edPaDlWa="false" edShNV="true" maDaHiDg="500,500" edAl="0" maSz="900,600" edPbW="280" maStEd="" edScDlWa="false" maInWs1="200,80,80,80" maNoWs4="80,50,250,100" maShGS="true" edScReWa="false" edShGrid="false" maBrMd="10" maNoWs3="80,50,180,50" edTbWfTbC="0" maMxIn="20" maTrW="240" edShWfM="false" maShMI="true"/>';
            sessionStorage.setItem('isFirstLogin', true);
            if (settings) {
                xml = zLib.decompressForm(settings);
                sessionStorage.setItem('isFirstLogin', false);
            }

            //window.localStorage.setItem('pfUserSettings', xml);

            const obj =  XJService.toJSON( xml );
            const settingsModel = new SettingsModel(obj.Settings);
            listService.userSettings = settingsModel;

            sessionStorage.setItem("timesDashBoardHelperShownL", 0);
            sessionStorage.setItem("timesDashBoardHelperShownD", 0);
            sessionStorage.setItem("timesDashBoardHelperShownR", 0);
            sessionStorage.setItem('timesGreetingWindowOpened', 0);
            sessionStorage.setItem("editorShowHelpCenterChanged", false);

            let helpCenterConfig = Number(listService.userSettings.get('_edShHC')).toString(2).split('');
            listService.userSettings.set('helpCenterConfig', helpCenterConfig);
        }
        catch (e) {
            console.log('could not set user settings');
        }
    }

    getUserSettings() {
        //return window.localStorage.getItem('pfUserSettings');
        let settings =listService.userSettings;

        // get from Local Storage in settings were lost in refresh.
        if (!settings || !settings.attributes) {
            settings = JSON.parse(window.localStorage.getItem('pfUserSettings'));
            settings = new SettingsModel( settings );
            listService.userSettings = settings;
        }

        return settings;
    }


    // Expects CLEARTEXT XML settings
    updateUserSettings(settings) {
        window.localStorage.setItem('pfUserSettings', settings);
    }

    get userSettings() {
        return this.getUserSettings();
    }

    mapUsers(userData, type){
        let users = [];
        if (userData.AllUsers && userData.AllUsers.User) {
            users = userData.AllUsers.User instanceof Array
                ? userData.AllUsers.User
                : [userData.AllUsers.User];
        }
        let items = [];
        let index = 0;
        users.forEach((item) => {
            if(item['@type'] === type){
                items.push( {
                    id: item['@id'],
                    label: item['@caption'],
                    listType: type,
                    items: item,
                    guid: item['@guid'],
                    targetIndex: index
                });

                index++;
            }            
        });

        return items;
    }

    populateUserSettingsFromApp() {

        let settings = listService.userSettings;

        settings.attributes._commonGroup = JSON.stringify(toolboxItemMapService.getLayoutItemsByGroup('common'));
        settings.attributes._behCommonGroup = JSON.stringify(toolboxItemMapService.getBehaviorItemsByGroup('common'));
        settings.attributes._repCommonGroup = JSON.stringify(toolboxItemMapService.getReportItemsByGroup('common'));
        settings.attributes._repBehCommonGroup = JSON.stringify(toolboxItemMapService.getReportBehaviorItemsByGroup('common'));

        const Settings = settings.attributes;

        const xml = XJService.jsToXml({Settings});

        console.log("XML", xml);

        return new XMLSerializer().serializeToString(xml);
    }

    getUserFeatures() {
        return JSON.parse( window.localStorage.getItem('pfUserFeatures') );
    }

    setUserFeatures(featuresValue) {
        const FEATURE_MOBILE_VIEWS = 512;
        const FEATURE_NOTIFICATION_ATTACHMENTS = 256;
        const FEATURE_SALESFORCE = 128;
        const FEATURE_SAP = 64;
        const FEATURE_GOOGLE_SPREADSHEET = 32;
        const FEATURE_ENCRYPTED = 16;
        const FEATURE_WEB_SIGNATURE = 8;
        const FEATURE_DB_API = 4;
        const FEATURE_DB_WORKFLOW = 2;
        const FEATURE_DB_CONNECTION = 1;

        //BU Specific
        const FEATURE_REPORTS = 1024;
        const FEATURE_SSO = 2048;
        const FEATURE_ADSYNC = 4096;
        const FEATURE_WSSOURCE = 8192;
        const FEATURE_ADVANCEDCSS = 16384;

        const hasFeature = (feature, mask) => {
            return feature ? feature & mask ? true : false : false;
          }

        let features = {
            DBConnection: false,
            DBWorkflow: false,
            DBAPI: false,
            WebSignature: false,
            Encrypted: false,
            GoogleSpreadsheet: false,
            SAP: false,
            SalesForce: false,
            NotificationAttachments: false,
            MobileViews: false,
            Reports: false,
            SSO: false,
            ADSync: false,
            WSSource: false,
            AdvancedCSS: false
        };

        features.DBConnection = hasFeature(featuresValue, FEATURE_DB_CONNECTION);
        features.DBWorkflow = hasFeature(featuresValue, FEATURE_DB_WORKFLOW);
        features.DBAPI = hasFeature(featuresValue, FEATURE_DB_API);
        features.WebSignature = hasFeature(featuresValue, FEATURE_WEB_SIGNATURE);
        features.Encrypted = hasFeature(featuresValue, FEATURE_ENCRYPTED);
        features.GoogleSpreadsheet = hasFeature(featuresValue, FEATURE_GOOGLE_SPREADSHEET);
        features.NotificationAttachments = hasFeature(featuresValue, FEATURE_NOTIFICATION_ATTACHMENTS);
        features.MobileViews = hasFeature(featuresValue, FEATURE_MOBILE_VIEWS);
        features.Reports = hasFeature(featuresValue, FEATURE_REPORTS);
        features.SSO = hasFeature(featuresValue, FEATURE_SSO);
        features.ADSync = hasFeature(featuresValue, FEATURE_ADSYNC);
        features.WSSource = hasFeature(featuresValue, FEATURE_WSSOURCE);
        features.AdvancedCSS = hasFeature(featuresValue, FEATURE_ADVANCEDCSS);

        try {
            window.localStorage.setItem('pfUserFeatures', JSON.stringify( features ));
        }
        catch (e) {
            console.log('could not set user features');
        }

    }

    checkFeatures(feature){
        let hasFeature = false;
        const features = this.getUserFeatures();
        if(feature === 'MobileViews' && features.MobileViews){
           hasFeature = true;
        }else if(feature === 'NotificationAttachments' && features.NotificationAttachments){
           hasFeature = true;
// TODO:   SalesForce and SAP are gonna be joined in one feature for Web Services in general.
//   Needs to fix it when the Admin Panel is ready
        }else if(feature === 'SalesForce' && features.SalesForce){
           hasFeature = true;
        }else if(feature === 'SAP' && features.SAP){
           hasFeature = true;
        }else if(feature === 'GoogleSpreadsheet' && features.GoogleSpreadsheet){
           hasFeature = true;
        }else if(feature === 'Encrypted' && features.Encrypted){
           hasFeature = true;
        }else if(feature === 'WebSignature' && features.WebSignature){
           hasFeature = true;
        }else if(feature === 'DBAPI' && features.DBAPI){
           hasFeature = true;
        }else if(feature === 'DBWorkflow' && features.DBWorkflow){
           hasFeature = true;
        }else if(feature === 'DBConnection' && features.DBConnection){
           hasFeature = true;
        }else if(feature === 'Report' && features.Reports){
            hasFeature = true;
        }else if(feature === 'SSO' && features.SSO){
            hasFeature = true;
        }else if(feature === 'ADSync' && features.ADSync){
            hasFeature = true;
        }else if(feature === 'WSSource' && features.WSSource){
            hasFeature = true;
        }else if(feature === 'AdvancedCSS' && features.AdvancedCSS){
            hasFeature = true;
        }

        return hasFeature;
    }

    getUserPermissionsByRoleNumber(roleNumber) {
        const PERMISSION_FAILED_NOTIFICATIONS = 1024;
        const PERMISSION_PUBLISH = 512;
        const PERMISSION_ARCHIVING = 256;
        const PERMISSION_FOLDERS = 128;
        const PERMISSION_EXTERNAL_PORTAL = 64;
        const PERMISSION_API = 32;
        const PERMISSION_ACCOUNT = 16;
        const PERMISSION_USERS = 8;
        const PERMISSION_CONNECTIONS = 4;
        const PERMISSION_REPORTS = 2;
        const PERMISSION_FORMS = 1;

        let permissions = {
            failedNotification: false,
            publish: false,
            archiving: false,
            folders: false,
            externalPortal: false,
            api: false,
            account: false,
            users: false,
            connections: false,
            reports: false,
            forms: false
        };

        let value = parseInt(roleNumber);
        while (value > 0) {

            if (value >= PERMISSION_FAILED_NOTIFICATIONS) {
                value = value - PERMISSION_FAILED_NOTIFICATIONS;
                permissions.failedNotification = true;
            }

            if (value >= PERMISSION_PUBLISH) {
                value = value - PERMISSION_PUBLISH;
                permissions.publish = true;
            }

            if (value >= PERMISSION_ARCHIVING) {
                value = value - PERMISSION_ARCHIVING;
                permissions.archiving = true;
            }

            if (value >= PERMISSION_FOLDERS) {
                value = value - PERMISSION_FOLDERS;
                permissions.folders = true;
            }

            if (value >= PERMISSION_EXTERNAL_PORTAL) {
                value = value - PERMISSION_EXTERNAL_PORTAL;
                permissions.externalPortal = true;
            }

            if (value >= PERMISSION_API) {
                value = value - PERMISSION_API;
                permissions.api = true;
            }

            if (value >= PERMISSION_ACCOUNT) {
                value = value - PERMISSION_ACCOUNT;
                permissions.account = true;
            }

            if (value >= PERMISSION_USERS) {
                value = value - PERMISSION_USERS;
                permissions.users = true;
            }

            if (value >= PERMISSION_CONNECTIONS) {
                value = value - PERMISSION_CONNECTIONS;
                permissions.connections = true;
            }

            if (value >= PERMISSION_REPORTS) {
                value = value - PERMISSION_REPORTS;
                permissions.reports = true;
            }

            if (value >= PERMISSION_FORMS) {
                value = value - PERMISSION_FORMS;
                permissions.forms = true;
            }
        }

        return permissions;
    }

    setUserRoles(roleNumber, libraryEnabled, archivingEnabled) {
        const PERMISSION_FAILED_NOTIFICATIONS = 1024;
        const PERMISSION_PUBLISH = 512;
        const PERMISSION_ARCHIVING = 256;
        const PERMISSION_FOLDERS = 128;
        const PERMISSION_EXTERNAL_PORTAL = 64;
        const PERMISSION_API = 32;
        const PERMISSION_ACCOUNT = 16;
        const PERMISSION_USERS = 8;
        const PERMISSION_CONNECTIONS = 4;
        const PERMISSION_REPORTS = 2;
        const PERMISSION_FORMS = 1;

        let permissions = {
            failedNotification: false,
            publish: false,
            archiving: false,
            folders: false,
            externalPortal: false,
            api: false,
            account: false,
            users: false,
            connections: false,
            reports: false,
            forms: false,
            libraryEnabled: false,
            archivingEnabled: false
        };

        let value = parseInt(roleNumber);
        while (value > 0) {

            if (value >= PERMISSION_FAILED_NOTIFICATIONS) {
                value = value - PERMISSION_FAILED_NOTIFICATIONS;
                permissions.failedNotification = true;
            }

            if (value >= PERMISSION_PUBLISH) {
                value = value - PERMISSION_PUBLISH;
                permissions.publish = true;
            }

            if (value >= PERMISSION_ARCHIVING) {
                value = value - PERMISSION_ARCHIVING;
                permissions.archiving = true;
            }

            if (value >= PERMISSION_FOLDERS) {
                value = value - PERMISSION_FOLDERS;
                permissions.folders = true;
            }

            if (value >= PERMISSION_EXTERNAL_PORTAL) {
                value = value - PERMISSION_EXTERNAL_PORTAL;
                permissions.externalPortal = true;
            }

            if (value >= PERMISSION_API) {
                value = value - PERMISSION_API;
                permissions.api = true;
            }

            if (value >= PERMISSION_ACCOUNT) {
                value = value - PERMISSION_ACCOUNT;
                permissions.account = true;
            }

            if (value >= PERMISSION_USERS) {
                value = value - PERMISSION_USERS;
                permissions.users = true;
            }

            if (value >= PERMISSION_CONNECTIONS) {
                value = value - PERMISSION_CONNECTIONS;
                permissions.connections = true;
            }

            if (value >= PERMISSION_REPORTS) {
                value = value - PERMISSION_REPORTS;
                permissions.reports = true;
            }

            if (value >= PERMISSION_FORMS) {
                value = value - PERMISSION_FORMS;
                permissions.forms = true;
            }
        }

        if(util.isTrue(libraryEnabled)){
            permissions.libraryEnabled = true;
        }

        if(util.isTrue(archivingEnabled)){
            permissions.archivingEnabled = true;
        }

         try {
            window.localStorage.setItem('pfUserRoles', JSON.stringify( permissions ));
        }
        catch (e) {
            console.log('could not set user roles');
        }
    }

    getUserRoles(){
        return JSON.parse( window.localStorage.getItem('pfUserRoles') );
    }

    getUserType(){
        return restService.getProfile().Status;
    }

    checkPermissions(role){
        let userType=restService.getProfile().Status;
        let hasRole = false;
        const roles = this.getUserRoles();
        if(role === 'libraryEnabled' && roles.libraryEnabled){
           hasRole = true;
        }else if(role === 'failedNotification' && roles.failedNotification){
           hasRole = true;
        }else if(role === 'publish' && roles.publish){
           hasRole = true;
        }else if(role === 'archiving' && roles.archiving){
           hasRole = true;
        }else if(role === 'folders'){
            if(userType==='1' || roles.folders){
                hasRole = true;
            }
        }else if(role === 'externalPortal' && roles.externalPortal){
           hasRole = true;
        }else if(role === 'api' && roles.api){
           hasRole = true;
        }else if(role === 'account' && roles.account){
           hasRole = true;
        }else if(role === 'users' && roles.users){
           hasRole = true;
        }else if(role === 'connections' && roles.connections){
           hasRole = true;
        }else if(role === 'Report' && roles.reports){
           hasRole = true;
        }else if((role === 'App' || role === 'Form') && roles.forms){
           hasRole = true;
        }else if(role === 'libraryEnabled' && roles.libraryEnabled){
           hasRole = true;
        }else if(role === 'archivingEnabled' && roles.archivingEnabled){
           hasRole = true;
        }

        return hasRole;
    }

    checkUserSession(){
        this.stopCheckingUserSession();
        listService.activeSession = setInterval(()=>{
            if (listService.isRecoverySave){
                console.log("Skip checking session, caught in the middle of auto recovery save");
                return;
            }
            console.log("checking user session " + util.toLocalDateTime(new Date(), 'DD MMM YYYY HH:mm:ss') + 
                        '\nlistService.activeSessionRetries: ' + listService.activeSessionRetries + 
                        '\nlistService.activeSession: ', listService.activeSession);
            const userId = restService.getProfile().UserId;
            listService.activeSessionRetries++;
                
            restService.checkUserSession(userId).then((response) => {

                console.log("user session check " + listService.activeSessionRetries + " of 3: user session active " + util.toLocalDateTime(new Date(), 'DD MMM YYYY HH:mm:ss'));
                listService.activeSessionRetries = 0;
                if (listService.activeSessionRetriesTimeout === constants.SESSION_TIMEOUT_RETRY_MS){ //Means it failed before but now it worked
                    listService.activeSessionRetriesTimeout = constants.SESSION_TIMEOUT_MS;                    
                    this.checkUserSession();
                }

            }).catch((err => {
                
                console.log(err);
                        
                if (listService.activeSessionRetries < 3) {
                    listService.activeSessionRetriesTimeout = constants.SESSION_TIMEOUT_RETRY_MS;
                    console.log("user session check " + listService.activeSessionRetries + " of 3: check was not successfull, retrying in " + constants.SESSION_TIMEOUT_RETRY_MS/1000 + " seconds. " + util.toLocalDateTime(new Date(), 'DD MMM YYYY HH:mm:ss'));
                    
                    if (listService.activeSessionRetriesTimeout === constants.SESSION_TIMEOUT_MS){ //Means it worked before but now it failed
                        listService.activeSessionRetriesTimeout = constants.SESSION_TIMEOUT_RETRY_MS;                    
                        this.checkUserSession();
                    }
                }
                else {
                    console.log("user session check " + listService.activeSessionRetries + " of 3:user session timed out " + util.toLocalDateTime(new Date(), 'DD MMM YYYY HH:mm:ss'));
                    listService.activeSessionRetries = 0;
                    
                    this.stopCheckingUserSession(); //No need for the interval anymore, the user will have to re-login
                    const sessionModal = new SessionTimeoutModal({ model: new Model({}) });
                    sessionModal.render().then(result => {
                        if (result === "close") {
                            undoService.clearChangeTracker();
                            Backbone.history.loadUrl('sessionTimeout');
                        }
                    });
                }
            }));
        }, listService.activeSessionRetriesTimeout);
    }

    stopCheckingUserSession(){
        if (listService.activeSession !== -1){
            clearInterval(listService.activeSession);
            console.log('Stopping interval that checks the validity of the user session, interval id: ' + listService.activeSession);
            listService.activeSession = -1;
        }
    }
}


const userService = new UserService();
export default userService;
